import './NewsFilter.scss'

import React, { FunctionComponent } from 'react'
import PuxIcon from 'Shared/components/PuxIcon/PuxIcon'
import { IEasySoftwareNewsCategory } from 'Shared/queries/page-queries'
import PuxLink from 'Shared/utils/PuxLink'
import { getLocalizedUrl } from 'Shared/utils/localeURL'
import { t } from 'ttag'

interface INewsFilter {
    data: IEasySoftwareNewsCategory[]
}

const NewsFilter: FunctionComponent<INewsFilter> = (props) => {
    return (
        <div className='NewsFilter'>
            <div className='NewsFilter-title'>
                {t`EasyRedmine.News.Filter.Title`}
            </div>
            <div className='NewsFilter-grid'>
                {props.data.map(category => {
                    return (
                        <PuxLink
                            className={`NewsFilter-item Button Button--ghost Button--sm${category.newsCategoryOrder === 0 ? ' NewsFilter-item--all' : ''}`}
                            activeClassName='is-active'
                            to={`${getLocalizedUrl(category.path)}`}
                        >
                            {category.newsCategoryOrder === 0 ? t`EasyRedmine.News.Filter.TitleAll` : category.displayText}
                            {category.newsCategoryIcon ? (
                                <div className='NewsFilter-itemIcon'>
                                    <PuxIcon
                                        name={category.newsCategoryIcon}
                                        size={12}
                                        decorative
                                    />
                                </div>
                            ) : null}
                        </PuxLink>
                    )
                })}
            </div>
        </div>
    )
}

export default NewsFilter
